// extracted by mini-css-extract-plugin
module.exports = {"mergeModal":"mergeModal__K292V","text":"text__yfHes","select":"select__+cwFI","list":"list__P9dmi","item":"item__zJBzS","check":"check__cqmsO"};